import "./styles.scss";

import { useTranslation } from "react-i18next";

import Header from "../../components/Header/NewHeader";
import SideMenu from "../../components/SideMenu/SideMenu";
import iconReportSVG from "../../assets/images/icons/report.svg";
import ContentCardReport from "../../components/report/ContentCardReport";

const Report = () => {
  const { t } = useTranslation();

  return (
    <div className="view">
      <SideMenu />

      <section>
        <Header typeIcon="custom" title={t("REPORT_FORM")} icon={<img src={iconReportSVG} alt="Report Icon" />} />

        <div className="content">
          <ContentCardReport />
        </div>
      </section>
    </div>
  );
};

export default Report;
